import React from 'react'; 
import { useNavigate } from 'react-router-dom';
import bedImg from '../../../img/beds.jpeg';  // Add the image import here

const ProductsBeds = () => {
  const navigate = useNavigate();

  const bedsProducts = [
    {
      bedNumber: "B001",
      description: "Elegant bed frame with classic wood finish, perfect for any bedroom.",
      imagen: bedImg  // Use the image variable here
    },
  ];

  const handleContactClick = () => {
    navigate('/contact');
  };

  return (
    <div className="container mx-auto px-4 py-20">
      <h1 className="text-3xl font-bold text-center mb-8">Beds Collection</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {bedsProducts.map((product) => (
          <div
            className="bg-white rounded-lg shadow-md overflow-hidden transform transition-transform duration-300 hover:scale-105 cursor-pointer flex flex-col h-full"
            key={product.bedNumber}
          >
            <img
              src={product.imagen}
              alt={`Bed ${product.bedNumber}`}
              className="w-full h-48 object-cover"
            />
            <div className="p-4 flex flex-col flex-grow">
              <h5 className="text-xl font-semibold text-gray-800 mb-2">
                Bed {product.bedNumber}
              </h5>
              <p className="text-sm text-gray-600 leading-relaxed flex-grow">
                {product.description}
              </p>
            </div>
          </div>
        ))}

        {/* Informative Card */}
        <div
          className="md:col-span-2 bg-emerald-800 rounded-lg shadow-md p-6 flex flex-col justify-between cursor-pointer hover:bg-emerald-700 transition-colors duration-300"
          onClick={handleContactClick}
        >
          <div>
            <h5 className="text-xl font-bold text-emerald-50 mb-4">Need More Information?</h5>
            <p className="text-emerald-100 mb-4">
              Interested in our beds? Want to discuss custom designs or get a quote? 
              Our team is ready to help you find the perfect bed for your project.
            </p>
            <p className="text-emerald-100">
              To view the complete list of products, please register to obtain your access token (key).
            </p>
          </div>
          <div className="mt-4">
            <span className="text-emerald-50 font-semibold hover:underline">
              Contact us →
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsBeds;
